import type { RouteRecordRaw } from "vue-router";
import { routes as membersRoutes } from "@/frontend/pages/fleets/[slug]/members/routes";
import { routes as logisticsRoutes } from "@/frontend/pages/fleets/[slug]/logistics/routes";
import { routes as settingsRoutes } from "@/frontend/pages/fleets/[slug]/settings/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "",
    name: "fleet",
    component: () => import("@/frontend/pages/fleets/[slug]/index.vue"),
    meta: {
      backgroundImage: "bg-8",
      customTitle: true,
    },
  },
  {
    path: "ships/",
    name: "fleet-ships",
    component: () => import("@/frontend/pages/fleets/[slug]/ships.vue"),
    meta: {
      backgroundImage: "bg-8",
      customTitle: true,
    },
  },
  {
    path: "fleetchart/",
    name: "fleet-fleetchart",
    redirect: {
      name: "fleet-ships",
      query: { fleetchart: "true" },
    },
  },
  {
    path: "members/",
    name: "fleet-members",
    component: () => import("@/frontend/pages/fleets/[slug]/members.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
    redirect: {
      name: membersRoutes[0].name,
    },
    children: membersRoutes,
  },
  {
    path: "logistics/",
    name: "fleet-logistics-root",
    component: () => import("@/frontend/pages/fleets/[slug]/logistics.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
    redirect: {
      name: logisticsRoutes[0].name,
    },
    children: logisticsRoutes,
  },
  {
    path: "settings/",
    name: "fleet-settings",
    component: () => import("@/frontend/pages/fleets/[slug]/settings.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      title: "fleets.settings.index",
      customTitle: true,
    },
    redirect: {
      name: settingsRoutes[0].name,
    },
    children: settingsRoutes,
  },
  {
    path: "stats/",
    name: "fleet-stats",
    component: () => import("@/frontend/pages/fleets/[slug]/stats.vue"),
    meta: {
      backgroundImage: "bg-8",
      title: "fleets.stats",
      customTitle: true,
    },
  },
];
